(ns practitest.frontend.vsadmin.views
  (:require
    [cljs.pprint :as pprint]
    [re-frame.core :as re-frame]
    ["react-c3js" :default C3Chart]
    [practitest.frontend.vsadmin.subs :as subs]))


(defn runs-linear-regression [x-data y-data x-trend y-trend]
  (let [x-data  (cons "Run-Score" (into () x-data))
        y-data  (cons "y-data" (into () y-data))
        x-trend (cons "Slope" (into () x-trend))
        y-trend (cons "y-trend" (into () y-trend))]
    [:>
     C3Chart
     {:style  {:width   "1000px"
               :padding "0"}
      :data   {:xs      {"Run-Score" "y-data",
                         :Slope      "y-trend"},
               :columns [x-data y-data x-trend y-trend]
               :types   {"Run-Score" "scatter",
                         :Slope      "spline"}}
      :legend {:show true}
      :axis   {"Run-Score" {:label "Days ago"
                            :show  true
                            :type  "indexed"}
               :y          {:label "Score"
                            :show  true}
               :y-trend    {:show true}}}]))

(defn graph-item []
  (let [x-d @(re-frame/subscribe [::subs/x-data])
        y-d @(re-frame/subscribe [::subs/y-data])
        x-t @(re-frame/subscribe [::subs/x-trend])
        y-t @(re-frame/subscribe [::subs/y-trend])]
    [:<>
     [:div.col-sm-12.col-md-12.col-lg-12
      [:p.bold "Runs linear regression"]
      [runs-linear-regression x-d y-d x-t y-t]]]))

(defn main-panel []
  [:div
   (case @(re-frame/subscribe [::subs/view])
     "vsadmin" [graph-item])])
